import { useMemo } from 'react';

import { PractitionerDetails } from '@dreryk/egabinet-personnel-frontend-api';
import { Address } from '@dreryk/address-common-api';

import { FormContextValues, useFormController } from '@dreryk/react-common';

import { DoctorPersonalDataPart, PersonalDataBean, SpecialistPersonalDataPart } from './PersonalDataForm.types';
import { getDoctorPersonalDataPart, getSpecialistPersonalDataPart } from './PersonalDataForm.utils';

type UsePersonalDataFormControllerOptions = {
   practitionerDetails: PractitionerDetails;
   updatingDoctorPersonalDataAvailable: boolean;
   doctorAddress: Address | undefined;
};

export const usePersonalDataFormController = (
   options: UsePersonalDataFormControllerOptions
): FormContextValues<PersonalDataBean<unknown>> => {
   const initialValues = useMemo<
      PersonalDataBean<unknown | DoctorPersonalDataPart | SpecialistPersonalDataPart>
   >(() => {
      const personalData: PersonalDataBean<unknown> = {
         firstName: options.practitionerDetails.firstName.asString(),
         lastName: options.practitionerDetails.lastName.asString(),
         emailAddress: options.practitionerDetails.emailAddress ?? null,
         phoneNumber: options.practitionerDetails.phoneNumber ?? null,
         title: options.practitionerDetails.title ?? null,
      };

      if (options.updatingDoctorPersonalDataAvailable) {
         return { ...personalData, ...getDoctorPersonalDataPart(options.practitionerDetails, options.doctorAddress) };
      }

      if (!options.updatingDoctorPersonalDataAvailable) {
         return { ...personalData, ...getSpecialistPersonalDataPart(options.practitionerDetails) };
      }

      return personalData;
   }, [options.practitionerDetails, options.updatingDoctorPersonalDataAvailable, options.doctorAddress]);

   return useFormController<PersonalDataBean<unknown>>(initialValues, {
      resetAfterSubmit: true,
   });
};
